import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltNotificationsPanelSettingsAccordionWireframe from './VeltNotificationsPanelSettingsAccordionWireframe/VeltNotificationsPanelSettingsAccordionWireframe';
var VeltNotificationsPanelSettingsListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-settings-list-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelSettingsListWireframe.Accordion = VeltNotificationsPanelSettingsAccordionWireframe;
export default VeltNotificationsPanelSettingsListWireframe;
